<template>
  <div>
    <div style="margin-bottom: 16px;">
      <span>是否要同时冻结设备：</span>
      <el-radio v-model="state" :label="0">不需要</el-radio>
      <el-radio v-model="state" :label="1">需要</el-radio>
    </div>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {updateForbiddenState} from "@/api/url";

export default {
name: "ForbiddenDialog",
  props: {
    value: Object
  },
  data() {
    return {
      state: 0,
      idArray: this.value.idArray,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      this.loading = true
      let param = {}
      param['idArr'] = this.idArray
      param['forbiddenState'] = 1
      param['idfaBanState'] = this.state
      postFormData(updateForbiddenState, param).then((data)=>{
        let {code, msg} = data
        if(code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
